export const countries = [
    {
      id: 'USA',
      name: 'United States',
      flag: 'https://flagcdn.com/w320/us.png',
      continent: 'North America',
      capital: 'Washington, D.C.',
      subregion: 'Northern America',
      area: 9372610,
      population: 331449281
    },
    {
      id: 'CAN',
      name: 'Canada',
      flag: 'https://flagcdn.com/w320/ca.png',
      continent: 'North America',
      capital: 'Ottawa',
      subregion: 'Northern America',
      area: 9984670,
      population: 38005238
    },
    {
      id: 'MEX',
      name: 'Mexico',
      flag: 'https://flagcdn.com/w320/mx.png',
      continent: 'North America',
      capital: 'Mexico City',
      subregion: 'Central America',
      area: 1964375,
      population: 130262216
    },
    {
      id: 'GBR',
      name: 'United Kingdom',
      flag: 'https://flagcdn.com/w320/gb.png',
      continent: 'Europe',
      capital: 'London',
      subregion: 'Northern Europe',
      area: 242900,
      population: 67886011
    },
    {
      id: 'DEU',
      name: 'Germany',
      flag: 'https://flagcdn.com/w320/de.png',
      continent: 'Europe',
      capital: 'Berlin',
      subregion: 'Western Europe',
      area: 357022,
      population: 83783942
    },
    {
      id: 'FRA',
      name: 'France',
      flag: 'https://flagcdn.com/w320/fr.png',
      continent: 'Europe',
      capital: 'Paris',
      subregion: 'Western Europe',
      area: 551695,
      population: 67564224
    },
    {
      id: 'ESP',
      name: 'Spain',
      flag: 'https://flagcdn.com/w320/es.png',
      continent: 'Europe',
      capital: 'Madrid',
      subregion: 'Southern Europe',
      area: 505990,
      population: 47329981
    },
    {
      id: 'ITA',
      name: 'Italy',
      flag: 'https://flagcdn.com/w320/it.png',
      continent: 'Europe',
      capital: 'Rome',
      subregion: 'Southern Europe',
      area: 301340,
      population: 60367460
    },
    {
      id: 'CHN',
      name: 'China',
      flag: 'https://flagcdn.com/w320/cn.png',
      continent: 'Asia',
      capital: 'Beijing',
      subregion: 'Eastern Asia',
      area: 9706961,
      population: 1444216107
    },
    {
      id: 'IND',
      name: 'India',
      flag: 'https://flagcdn.com/w320/in.png',
      continent: 'Asia',
      capital: 'New Delhi',
      subregion: 'Southern Asia',
      area: 3287263,
      population: 1393409038
    },
    {
      id: 'JPN',
      name: 'Japan',
      flag: 'https://flagcdn.com/w320/jp.png',
      continent: 'Asia',
      capital: 'Tokyo',
      subregion: 'Eastern Asia',
      area: 377930,
      population: 126476461
    },
    {
      id: 'BRA',
      name: 'Brazil',
      flag: 'https://flagcdn.com/w320/br.png',
      continent: 'South America',
      capital: 'Brasília',
      subregion: 'South America',
      area: 8515767,
      population: 213993437
    },
    {
      id: 'ARG',
      name: 'Argentina',
      flag: 'https://flagcdn.com/w320/ar.png',
      continent: 'South America',
      capital: 'Buenos Aires',
      subregion: 'South America',
      area: 2780400,
      population: 45195777
    },
    {
      id: 'AUS',
      name: 'Australia',
      flag: 'https://flagcdn.com/w320/au.png',
      continent: 'Oceania',
      capital: 'Canberra',
      subregion: 'Australia and New Zealand',
      area: 7692024,
      population: 25788220
    },
    {
      id: 'RUS',
      name: 'Russia',
      flag: 'https://flagcdn.com/w320/ru.png',
      continent: 'Europe',
      capital: 'Moscow',
      subregion: 'Eastern Europe',
      area: 17098242,
      population: 145912025
    },
    {
      id: 'ZAF',
      name: 'South Africa',
      flag: 'https://flagcdn.com/w320/za.png',
      continent: 'Africa',
      capital: 'Pretoria',
      subregion: 'Southern Africa',
      area: 1221037,
      population: 59308690
    },
    {
      id: 'NGA',
      name: 'Nigeria',
      flag: 'https://flagcdn.com/w320/ng.png',
      continent: 'Africa',
      capital: 'Abuja',
      subregion: 'Western Africa',
      area: 923768,
      population: 206139587
    },
    {
      id: 'EGY',
      name: 'Egypt',
      flag: 'https://flagcdn.com/w320/eg.png',
      continent: 'Africa',
      capital: 'Cairo',
      subregion: 'Northern Africa',
      area: 1002450,
      population: 104258327
    },
    {
      id: 'SAU',
      name: 'Saudi Arabia',
      flag: 'https://flagcdn.com/w320/sa.png',
      continent: 'Asia',
      capital: 'Riyadh',
      subregion: 'Western Asia',
      area: 2149690,
      population: 34813871
    },
    {
      id: 'KOR',
      name: 'South Korea',
      flag: 'https://flagcdn.com/w320/kr.png',
      continent: 'Asia',
      capital: 'Seoul',
      subregion: 'Eastern Asia',
      area: 100210,
      population: 51780579
    }
  ];

  export const activities = [
    {
      name: 'Hiking',
      difficulty: '3',
      duration: '4 hours',
      season: 'Summer',
      countries: ['USA', 'Canada']
    },
    {
      name: 'Skiing',
      difficulty: '4',
      duration: 'Full day',
      season: 'Winter',
      countries: ['Canada', 'Switzerland']
    },
    {
      name: 'Surfing',
      difficulty: '2',
      duration: '2 hours',
      season: 'Summer',
      countries: ['Australia', 'USA']
    },
    {
      name: 'Mountain Biking',
      difficulty: '4',
      duration: 'Half day',
      season: 'Spring',
      countries: ['USA', 'Canada']
    },
    {
      name: 'Sightseeing',
      difficulty: '1',
      duration: 'Flexible',
      season: 'Autum',
      countries: ['France', 'Italy', 'Spain']
    }
  ];